import React from 'react'
import './styles.css'

interface CheckboxProps {
  checked: boolean,
  onToggle: any,
}
export const Checkbox = (props: CheckboxProps) =>
<button className="rasa-checkbox" onClick={props.onToggle}>
  {props.checked ? <i className="fas fa-check"></i> : null}
</button>
